import React from 'react';
import PropTypes from 'prop-types';
import css from './accuracy-graph.scss';

import { drawHorizontalBarLines, renderGraph } from './accuracy-graph.utils';

export const AccuracyGraph = ({ averageAccuracies }) => (
    <div className={css.barsContainer}>
        {drawHorizontalBarLines(averageAccuracies)}
        <div className={css.graphContainer}>
            {renderGraph(averageAccuracies)}
        </div>
    </div>
);

AccuracyGraph.propTypes = {
    averageAccuracies: PropTypes.array
};

AccuracyGraph.defaultProps = {
    averageAccuracies: []
};



// WEBPACK FOOTER //
// ./components/accuracy-graph/accuracy-graph.js